// src/utils/navigation/recordingGuideNav.js

/**
 * recordingGuideNav
 * -----------------
 * Utilities for deriving a recording-guide route from the current location.
 *
 * We intentionally derive the target path from the URL rather than relying on
 * variant props, so this works for any recording variant and for future pods
 * without requiring host-side wiring changes.
 *
 * Supported patterns
 * ------------------
 * • /recording/<variant>/camera  -> /recording/<variant>/guide
 *
 * Non-matches return null to indicate "do not show a guide button".
 */

/**
 * Returns the guide path if the current path is a recording camera route.
 *
 * @param {string} pathname - Location pathname (e.g. window.location.pathname)
 * @returns {string|null} Guide path (e.g. "/recording/spirometry/guide") or null if not applicable.
 */
export function getGuidePathFromCameraPath(pathname) {
  if (typeof pathname !== "string") return null;

  // Match: /recording/<variant>/camera (with optional trailing slash)
  const m = pathname.match(/^\/recording\/([^/]+)\/camera\/?$/);
  if (!m) return null;

  const variantSegment = m[1];
  return `/recording/${variantSegment}/guide`;
}
